export const User = ({
  email, lastName, firstName, _id,
}) => ({
  email, lastName, firstName, _id,
});
